import { Badge, Button, Tooltip } from "@smart/itops-sb-design-system-dom";

type ConditionsButtonProps = {
  numberOfConditions?: number;
  onClick: () => void;
  size?: "default" | "small";
  max?: number;
  dataTestId?: string;
  disabled?: boolean;
};

export const ConditionsButton = ({
  numberOfConditions,
  onClick,
  max = 9,
  size,
  dataTestId,
  disabled,
}: ConditionsButtonProps) => {
  const isOverMax = numberOfConditions && numberOfConditions > max;
  const label = isOverMax ? (
    <span className="flex ml-[0.3rem]">
      {max}
      <span className="text-[0.9rem]">+</span>
    </span>
  ) : (
    `${numberOfConditions}`
  );

  return (
    <Tooltip
      className="flex items-center"
      title="Conditions"
      text="Set conditions to show or hide fields dynamically"
      placement="top-end"
      offsetBy={7}
      variant="paragraphy"
    >
      <div className="relative">
        {!!numberOfConditions && (
          <div className="absolute top-[0.3rem] left-[0.3rem] -translate-x-[50%] -translate-y-[35%] z-1">
            <Badge
              label={label}
              isRound
              theme="destructive"
              isShade
              className="w-[1.6rem] h-[1.6rem] leading-[1.6rem] rounded-full"
              dataTestId="number-of-conditions-badge"
            />
          </div>
        )}
        <Button
          leftIcon={
            numberOfConditions
              ? "solidArrowsSplitUpAndLeft"
              : "regularArrowsSplitUpAndLeft"
          }
          isPressed={!!numberOfConditions}
          variant="secondarySubtle"
          className="focus:before:inset-0"
          onClick={onClick}
          size={size}
          dataTestId={dataTestId || "conditions-button"}
          disabled={disabled}
        />
      </div>
    </Tooltip>
  );
};
